import React from 'react';
import { useProjectDocs } from '../hooks/useProjectDocs';
import { cn } from '@/utils/cn';

export function ProjectDocsFolderTree() {
  const { folders, isLoading } = useProjectDocs();

  return (
    <div className="space-y-6">
      {/* Thư mục */}
      <div className="bg-white rounded-md border border-slate-100  overflow-hidden">
        <div className="p-4 border-b border-slate-50 flex items-center justify-between">
          <div className="flex items-center gap-2">
             <i className="ri-folder-open-line text-emerald-600 text-lg" />
             <h3 className="text-sm font-normal text-slate-900 tracking-wider">Thư mục tài liệu</h3>
          </div>
          <button className="w-6 h-6 rounded-md bg-emerald-50 text-emerald-600 flex items-center justify-center hover:bg-emerald-100 transition-colors">
            <i className="ri-add-line" />
          </button>
        </div>
        
        <div className="p-2 space-y-1">
          {isLoading ? (
            Array.from({ length: 5 }).map((_, i) => <div key={i} className="h-10 animate-pulse bg-slate-50 rounded-md" />)
          ) : (
            folders.map((folder, idx) => (
              <button 
                key={folder.id}
                className={cn(
                  "w-full flex items-center justify-between p-2 rounded-md transition-all group",
                  idx === 0 ? "bg-emerald-50 text-emerald-600" : "text-slate-600 hover:bg-slate-50"
                )}
              >
                <div className="flex items-center gap-3">
                  <i className={cn("ri-folder-fill text-lg", idx === 0 ? "text-emerald-500" : "text-amber-400 group-hover:text-amber-500")} />
                  <span className="text-xs font-normal truncate max-w-[150px]">{folder.name}</span>
                </div>
                <span className="text-xs font-normal px-1.5 py-0.5 rounded-full bg-white/50 border border-slate-100  min-w-[24px] text-center">
                  {folder.count}
                </span>
              </button>
            ))
          )}
        </div>
      </div>

      {/* Dung lượng lưu trữ */}
      <div className="bg-white rounded-md border border-slate-100 p-4  space-y-3">
        <h3 className="text-xs font-normal text-slate-900 tracking-wider">Dung lượng đã sử dụng</h3>
        <div className="space-y-2">
          <div className="h-1.5 rounded-full bg-slate-100 overflow-hidden">
            <div className="h-full bg-emerald-500" style={{ width: '32%' }} />
          </div>
          <div className="flex justify-between items-center text-xs font-normal">
             <span className="text-emerald-600">6.45 GB</span>
             <span className="text-slate-400">/ 20 GB (32%)</span>
          </div>
        </div>
      </div>
    </div>
  );
}
